export const logOut = () => {
  sessionStorage.removeItem("access");
  sessionStorage.removeItem("refresh");
  sessionStorage.removeItem("code");
  sessionStorage.removeItem("session_state");
  window.location.replace("/");
};
